module.exports = __webpack_public_path__ + "AssetXpertSchemaxTwo.6fddaa3.jpg";